import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import Allowance from 'modules/timeoff/store/models/Allowance'

class Allowances extends Collection<Allowance> {
  constructor(data: Allowance[] = []) {
    super(data)
    makeObservable(this, {
      sortedByPosition: computed,
    })
  }

  get cacheKey(): string {
    return 'allowances'
  }

  model() {
    return Allowance
  }

  get sortedByPosition() {
    return this.models.slice().sort((a, b) => a.attributes.position - b.attributes.position)
  }
}

const singleton: Allowances = new Allowances()

export default singleton
